import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import ThemeProvider from './ThemeProvider';
import configureStore from '../store';
import GlobalStyle from '../styles/GlobalStyle';
import BreadcrumbsProvider from '~/providers/BreadcrumbsProvider';

const store = configureStore();

function AppProvider({ children }) {
  return (
    <Provider store={store}>
      <BreadcrumbsProvider>
        <ThemeProvider>
          <GlobalStyle />
          {children}
        </ThemeProvider>
      </BreadcrumbsProvider>
    </Provider>
  );
}

AppProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.object,
  ]),
};

AppProvider.defaultProps = {
  children: null,
};

export default AppProvider;
